var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.082 12.263h24.172c.589 0 1.106.397 1.253.97l5.913 22.785H15.245L9.082 12.263z",
    fill: "url(#Calender_svg__paint0_linear_2680_46299)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.082 12.263h24.805a.54.54 0 01.505.342l8.358 20.971H17.376L9.284 12.418l-.202-.155z",
    fill: "url(#Calender_svg__paint1_linear_2680_46299)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.553 19.074h3.38c.279 0 .525.167.628.426l1.4 3.51a.417.417 0 01-.39.573h-3.435a.676.676 0 01-.632-.433l-1.345-3.507a.42.42 0 01.39-.569h.004zM18.852 25.448h3.38c.278 0 .524.167.628.426l1.4 3.51a.417.417 0 01-.39.573h-3.436a.676.676 0 01-.632-.433l-1.344-3.507a.42.42 0 01.39-.569h.004zM30.177 29.974h-3.158a.826.826 0 01-.767-.529l-1.233-3.225a.583.583 0 01.545-.795h3.105a.82.82 0 01.764.517l1.284 3.225a.583.583 0 01-.54.8v.007zm-4.61-4.144a.183.183 0 00-.154.08.176.176 0 00-.02.17l1.233 3.226c.063.163.222.27.393.27h3.158c.063 0 .119-.028.155-.083a.184.184 0 00.02-.175l-1.285-3.225a.419.419 0 00-.394-.267h-3.105v.004zM23.067 19.074h3.38c.278 0 .524.167.628.426l1.4 3.51a.417.417 0 01-.39.573h-3.436a.676.676 0 01-.632-.433l-1.344-3.507a.42.42 0 01.39-.569h.004zM29.576 19.074h3.38c.278 0 .525.167.628.426l1.4 3.51a.417.417 0 01-.39.573H31.16a.676.676 0 01-.633-.433l-1.344-3.507a.42.42 0 01.39-.569h.004z",
    fill: "#B5B5B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.755 36.014h12.657L9.284 12.418c-.055-.207-.35-.207-.405 0L2.755 36.014z",
    fill: "url(#Calender_svg__paint2_linear_2680_46299)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22 36.014h11.723L9.08 13.435l-5.86 22.579z",
    fill: "url(#Calender_svg__paint3_linear_2680_46299)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.652 15.937a.796.796 0 01-.322-1.523c.513-.227 1.03-1.038 1.03-2.155 0-1.312-.716-2.227-1.357-2.227-.64 0-1.34.89-1.355 2.175v.048h-1.591v-.044c.016-2.12 1.304-3.774 2.946-3.774 1.643 0 2.947 1.679 2.947 3.818 0 1.634-.795 3.086-1.98 3.61a.769.769 0 01-.322.068l.004.004z",
    fill: "url(#Calender_svg__paint4_radial_2680_46299)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.858 15.937a.796.796 0 01-.322-1.523c.512-.227 1.03-1.038 1.03-2.155 0-1.312-.716-2.227-1.357-2.227-.64 0-1.34.89-1.356 2.175v.048h-1.59v-.044c.016-2.12 1.304-3.774 2.946-3.774 1.643 0 2.947 1.679 2.947 3.818 0 1.634-.795 3.086-1.98 3.61a.769.769 0 01-.322.068l.004.004z",
    fill: "url(#Calender_svg__paint5_radial_2680_46299)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 33.577h1.137l5.496-21.159L2.25 33.577z",
    fill: "url(#Calender_svg__paint6_linear_2680_46299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Calender_svg__paint0_linear_2680_46299",
    x1: 14.128,
    y1: 36.841,
    x2: 36.666,
    y2: 9.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Calender_svg__paint1_linear_2680_46299",
    x1: 22.283,
    y1: 30.141,
    x2: 74.363,
    y2: -73.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Calender_svg__paint2_linear_2680_46299",
    x1: 11.225,
    y1: 12.979,
    x2: 6.72,
    y2: 61.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Calender_svg__paint3_linear_2680_46299",
    x1: -1.941,
    y1: 29.648,
    x2: 17.778,
    y2: 22.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Calender_svg__paint6_linear_2680_46299",
    x1: -4.395,
    y1: 27.23,
    x2: 9.499,
    y2: 21.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Calender_svg__paint4_radial_2680_46299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.495 9.487) scale(7.76201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Calender_svg__paint5_radial_2680_46299",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7 8.644) scale(.19882)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
export default SvgCalender;